import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import firebaseConfig from './firebase-config-prod';
  
firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App db={firebase.database()} />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js